export default __webpack_public_path__ + "static/media/flag-guinea.06615659.svg";